import { i18n as _i18n } from "@lingui/core";
import { formNames } from '@wkda/carlead-creation-form';
import { useModulesStore } from '@wkda/funnel-components';
import { GenericFieldBoxSelect } from './GenericFieldBoxSelect';
import { jsx as _jsx } from "react/jsx-runtime";
export function SplitMainTypeDetails(_ref) {
  let {
    label = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.label.mainTypeDetail'
    }),
    ...props
  } = _ref;
  const {
    carTypesSplitModule: {
      getMainTypesDetails
    }
  } = useModulesStore();
  return /*#__PURE__*/_jsx(GenericFieldBoxSelect, {
    columnClassName: "col-4",
    label: label,
    name: formNames.mainTypeDetail,
    dataQueryFn: getMainTypesDetails,
    ...props
  });
}